import {useRequest, useInfiniteScroll} from "ahooks";
import React, {useEffect, useRef} from "react";
import {Stack, Box, CircularProgress, Typography, useTheme} from "@mui/material";
import {getCardApplyList, getCardBillList, getMessageList} from '@/services'
import {useState} from "react";
import LoadMore from "@/components/LoadMore";
import dayjs from "dayjs";
import classes from './index.module.css'
import {useTranslation} from "react-i18next";
import TransItem from "@/components/skeleton/TransItem";
import axiosInstance from "@/utils/axios";
import { dispatch } from "@/redux/store";
import { onUnreadMsgCount } from "@/redux/slices/user";
import API from "@/constant/API";
import theme from "@/redux/slices/theme";

interface Props {
  onLoad?: (data: any) => void
}

const MessageList = ({onLoad}: Props) => {
  const ref = useRef(null);
  const {t} = useTranslation();
  const theme = useTheme();
  const [pageNum, setPageNum] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const setLastFlagRef = useRef(false);
  const getList = async (current = 1) => {
    const res = await getMessageList(current, pageSize)
    const result = {
      list: res?.list || [],
      total: res?.total || 0,
      page: current,
    };
    return result;
  }

  const {data, loading, loadMore, loadingMore, noMore} = useInfiniteScroll((d) => {
    const page = d ? d.page + 1 : 1
    return getList(page);
  }, {
    target: ref,
    isNoMore: (d) => {
      // d?.total <= d.list.length,
      return (d && d.list.length >= d.total)
    }
  });

  useEffect(() => {
    if (data) {
      onLoad(data)
      if (data.list?.length && !setLastFlagRef.current) {
        _setLast(data.list);
      }
    }
  }, [data]);

  const _setLast = async (list) => {
    // set last
    await axiosInstance.post(API.MSG_SET_LAST, {
      lastMessageId: list[0].id,
    });

    // refresh unread message count
    dispatch(onUnreadMsgCount());

    setLastFlagRef.current = true;
  }

  return (<>
    <Stack gap={'24px'}
           direction="column"
           sx={{flex: 1, overflow: 'hidden', width: '100%', height: '100%', padding: '0 24px 16px'}}>
      <Typography className={classes.title}
                  sx={theme => ({fontSize: '28px'})}
      >{t('notifications')}</Typography>
      <Box direction="column" sx={{flex: 1, height: '400px', overflow: 'auto'}}  ref={ref} className={classes.scollWrapper}>
        {loading ? (
          <Stack sx={{padding: '16px'}} direction="column" justifyContent="center">
            <TransItem/>
            <TransItem/>
            <TransItem/>
          </Stack>
        ) : (
          <Stack direction="column" gap="32px">
            {data?.list && data?.list?.map((item, idx) => (
              <Stack key={item.title + idx} direction="row" gap="12px">
                <Stack style={{height: 20}} direction="column" alignItems="center">
                  {/*{item.unRead && <Box component="span"*/}
                  {/*  sx={theme => {*/}
                  {/*    return {*/}
                  {/*      backgroundColor: theme.palette.text.primary*/}
                  {/*    }*/}
                  {/*  }}*/}
                  {/*  className={classes.dot}></Box>}*/}
                  </Stack>
                <Stack>
                  <Stack direction="row" alignItems="center"
                  >
                    <i
                    style={{
                      width: '8px',
                      height: '8px',
                      backgroundColor: item.unread ? theme.palette.text.primary : theme.palette.text.tertiary,
                      borderRadius: '50%',
                    }}
                    />
                    <Typography sx={theme => {
                      return {
                        fontSize: theme.typography.pxToRem(15),
                        paddingLeft: '12px',
                        color: item.unread ? theme.palette.text.primary : theme.palette.text.tertiary
                      }
                    }}>{item.title}</Typography>
                  </Stack>

                  <Typography
                  sx={{
                    paddingLeft: '20px',
                    color: theme.palette.text.tertiary
                  }}
                  >{item.body}</Typography>
                  <Typography
                    sx={{
                      paddingLeft: '20px',
                      color: theme.palette.text.tertiary
                    }}
                  >{dayjs(item.createTime).format('YYYY.MM.DD')}</Typography>
                </Stack>
              </Stack>
            ))}
          </Stack>
        )}
        <div style={{marginTop: 8}}>
          {!noMore && (
            <Box>
              <LoadMore disabled={loadingMore} loading={loadingMore} hasMore={!noMore} onClick={() => {
                // loadMore
              }}/>
            </Box>
          )}
          {/*{noMore && <span>No more data</span>}*/}
        </div>
      </Box>
    </Stack>
  </>)
}

export default MessageList;